import React from "react";
import "./LoadingSpinner.css";
import {Box, Typography} from "@mui/material";

export default function LoadingSpinner(props) {
  return <Box className="loading-container" style={props.style}>
    <Box className="spinner-container" margin={"20px"} display="grid">
      <Box className="loading-spinner"/>
      <Typography style={{margin: "auto", marginTop: "20px", textAlign: "center", maxWidth: "500px"}}
                  variant={"overline"}>{props.statusMessage}</Typography>
    </Box>
  </Box>;
}